import React from 'react'
import cs from 'classnames'
import { isIos } from 'src/utils/helpers'

import SvgIcon from 'src/components/SvgIcon'

import styles from './styles.module.less'
import { FormattedMessage } from 'react-intl'

export default function Intro() {
  return (
    <section className={cs(styles.introContent)}>
      <header>
        <SvgIcon size='lg' type='LockIcon' style={{ margin: '10px auto' }} />
        <h2>
          <FormattedMessage id='app.lock.screen.header.privacy' defaultMessage='Privacy' />
        </h2>
        <p>
          <FormattedMessage
            id='app.lock.screen.guidedAccess'
            defaultMessage='Turn on Guided access'
          />
        </p>
      </header>
      {!isIos() && (
        <section>
          <p>
            <FormattedMessage
              id='app.lock.intro.p1'
              defaultMessage='Steps may differ depending on device manufacturer and Android version.'
            />
          </p>
        </section>
      )}
      <footer>
        <SvgIcon size='md' type='SwipeLeft' style={{ margin: '10px auto' }} />
      </footer>
    </section>
  )
}
